import axios from 'axios';
const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_IFS,
  headers: { 'Content-Type': 'application/json' },
});

export default instance;
// instance.defaults.headers.common['Content-Type'] = 'multipart/form-data';
